import services from './services.js';
import Tree from "Tree";
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    MAP_LIST
} from '$http';
import selectStaffDialog from 'selectStaffDialog';
import selectAreaDialog from 'selectAreaDialog';


export default {
    components: {
        Tree,
        selectStaffDialog,
        selectAreaDialog
    },
    mixins: [services],
    data() {
        return {
            /* 主表数据 */
            loading: false,
            lists: [], //表格内容
            pageIndex: 1,
            pageSize: 10,
            totalSize: '',
            pageSizes: [10, 20, 50],
            sels: [], //列表选中
            /*添加员工弹窗*/
            checkedProvinceList: [],
            queryEmployName: "", //员工弹窗名称搜索
            SearchuserName: "", //主页搜索名称
            AddEmployeeVisible: false, //控制弹窗的显示与隐藏 
            ActionManage: false, //选择员工弹窗
            actionPartmentVisible: false, //选择部门弹窗的显示和隐藏
            TreeDataList: [], //树级数据
            SubjectDemo: MAP_LIST.INTENT_PROJECT, //隶属项目
            DataAuthoritys: [{
                id: -1,
                name: "全部"
            }, {
                id: 0,
                name: "测试"
            }, {
                id: 1,
                name: "正式"
            }], //数据权限配置
            WorkAddress: [], //工作地
            Partment: {}, //选择部门临时数据存放对象
            ActionPartment: {}, //确定了部门存放的对象
            ManageData: [], //部门的直找经理的数据
            ShortEmployeeData: {}, //选择部门临时数据
            ActionEmployee: {
                name: "",
                ID: ""
            }, //确定了部门员工后的存储与对象
            edit: false, //是否编辑---用于判断是调用添加接口还是修改接口
            view: false, //是否查看
            TitleContent: "", //添加或修改的文字展示内容
            /*提交表单绑定数据*/
            Form: this.getFormData(),
            provinceTextarea: "",
            yjListBtnName: ['设备'],
            checkedListBtnName: [],
            rules: {},
            isShow: [false],
            isDisable: true, //离职日期
            query: this.getSearchData(),
            searchArea: false //作为搜索区域选择所属部门标志
        }
    },
    watch: {
        Form: {
            deep: true,
            handler() {
                if (this.Form.Subjection === 0) {
                    this.Form.Subjection = null;
                }
                if (this.Form.WorkAddress === 0) {
                    this.Form.WorkAddress = null;
                }
            }
        }
    },
    methods: {
        // 搜索条件
        getSearchData() {
            return cloneDeep({
                userName: '', //员工名字
                workAddress: '', //工作地
                deptId: '', //所属部门
                employeeProperty: '', //员工属性
                entryStartDate: '', //入职日期start
                entryEndDate: '', //入职日期end
                workTime: '', //工龄
                status: '', //状态
                d_name: '全部'
            })
        },
        getFormData() {
            return cloneDeep({
                "uid": "", //账号
                "Name": "", //姓名
                "IdCard": "", //身份证
                "Birthday": "", //生日
                "d_id": 0, //部门
                "Email": "", //邮箱
                "Sex": "", //性别
                "Tel": "", //电话
                "Status": "", //状态
                "Sort": 0, //人员排序
                "EntryDate": "", //入职日期
                "Address": "", //地址
                "Remarks": "", //备注
                "Education": "", //教育经历
                "Professional": "", //专业
                "Schools": "", //毕业院校
                "CanLogin": 1, //可登陆
                "Subjection": [], //隶属项目--下拉框支持整数型显示
                "DataAuthority": 1,
                "ExtNumber": "", //考勤号
                "WorkAddress": null, //工作地--下拉框支持整数型显示
                "IMEI": "", //分机号
                "EntEmail": "", //企业邮箱
                "LineManager": 0, //直找经理
                "ModuleRoleList": [{
                    ProvRoles: [],
                    "ModuleId": 0,
                    "ListProvRole": [],
                    "ListProjectRole": []
                }, {
                    ProvRoles: [],
                    "ModuleId": 1,
                    "ListProjectRole": []
                }, {
                    ProvRoles: [],
                    "ModuleId": 2,
                    "ListProjectRole": [],
                    ListBtnName: []
                }],
                //劳动合同时间
                LaborRelations: [{
                    StartDate: '',
                    EndDate: ''
                }],
                EmpCod: "", //雇员编号
                LeaveDate: "", //离职时间
                EmployeeProperty: "", //员工属性
                BankName: "", //银行名称
                BankOpenAddress: "", //开户行
                BankNumber: "", //银行卡号

            });
        },
        selsChange: function (sels) {
            this.sels = sels;
        },
        //搜索条件新增选择所属公司/中心/部门
        changeCompany() {
            this.actionPartmentVisible = true;
            this.searchArea = true
        },
        // 劳动合同日期新增与删除
        removeDomain(item) {
            var index = this.Form.LaborRelations.indexOf(item)
            if (index !== -1) {
                this.Form.LaborRelations.splice(index, 1)
            }
        },
        addDomain() {
            this.isShow[this.Form.LaborRelations.length] = true;
            this.Form.LaborRelations.push({
                StartDate: '',
                EndDate: ''
            });
        },
        Submit(formName) {
            let rule = [{
                name: "姓名",
                value: this.Form.Name,
                required: true
            }, {
                name: "性别",
                value: this.Form.Sex,
                required: true
            }, {
                name: "生日",
                value: this.Form.Birthday,
                required: true
            }, {
                name: "手机号",
                value: this.Form.Tel,
                phone: true
            }, {
                name: "账号",
                value: this.Form.uid,
                required: true
            }, {
                name: "状态",
                value: this.Form.Status,
                required: true
            }, {
                name: "入职日期",
                value: this.Form.EntryDate,
                required: true
            }, {
                name: "员工属性",
                value: this.Form.EmployeeProperty,
                required: true
            }, {
                name: "工作地",
                value: this.Form.WorkAddress,
                required: true
            }, {
                name: "部门",
                value: this.Form.WorkAddress,
                required: true
            }]

            if (!this.isDisable) {
                rule.push({
                    name: "离职日期",
                    value: this.Form.LeaveDate,
                    required: true
                })
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    var flag = util.checkForm({
                        ele: this,
                        rules: rule
                    });

                    if (!flag) {
                        return;
                    }

                    // 过滤劳动合同为空的
                    console.log(this.Form.LaborRelations)
                    for (let i = 0; i < this.Form.LaborRelations.length; i++) {
                        //去除空的数组
                        if (!this.Form.LaborRelations[i].StartDate) {
                            this.Form.LaborRelations.splice(i, 1);
                        }
                    }
                    // 权限不判断
                    // if (this.Form.ModuleRoleList[0].ListProjectRole.length > 0 && $.trim(this.provinceTextarea).length == 0) {
                    //     this.$notify({
                    //         title: '警告',
                    //         message: "请设置权限",
                    //         type: 'warning'
                    //     });
                    //     return;
                    // } else if (this.Form.ModuleRoleList[0].ListProjectRole.length == 0 && $.trim(this.provinceTextarea).length > 0) {
                    //     this.$notify({
                    //         title: '警告',
                    //         message: "请设置权限",
                    //         type: 'warning'
                    //     });
                    //     return;
                    // }

                    let params = cloneDeep(this.Form);
                    params.d_id = this.ActionPartment.Id;
                    params.LineManager = this.ActionEmployee.ID;
                    params.Subjection = this.Form.Subjection.join(",");
                    params.ModuleRoleList[2].ListBtnName = this.checkedListBtnName;
                    if (this.edit === true) {
                        delete params.d_Name;
                        delete params.LineManagerName;
                        this.EmployeeUpdate(params); //修改
                    } else {
                        this.EmployeeAdd(params); //新增
                    }
                }
            });

        },
        deleteEmployee() {
            var ids = this.sels.map(item => item.ID).toString();
            var Params = {
                "Ids": ids
            };
            if (ids == "") {
                this.$notify({
                    title: '提示',
                    message: '还没有选择删除内容',
                    type: 'warning'
                });
            } else {
                this.$confirm('确认删除选中记录吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.EmployeeDel(Params)
                });
            }

        },
        /*选择部门弹窗函数*/
        // 点击树级部门将当前选中的节点赋值给Partment
        handleActionPartment(value) {
            this.Partment = value;
        },
        //选择部门弹出显示确定
        PartmentSure() {
            if (this.searchArea) {
                //为搜索区域弹窗
                this.query.deptId = this.Partment.Id
                this.query.d_name = this.Partment.D_Name
                this.searchArea = false
            } else {
                this.ActionPartment = this.Partment;
                console.log(this.ActionPartment)
                this.GetLineManage(this.ActionPartment.Id); //选择部门后默认获取直线经理
            }

            this.actionPartmentVisible = false;
        },
        //点击选择部门，弹窗显示
        actionPartment() {
            this.actionPartmentVisible = true;
        },
        actionManage() {
            //this.ActionManage = true;
            this.$refs.refSelectStaffDialog.show();
        },
        //选择员工状态
        changeStadus(val) {
            if (val == '离职') {
                this.isDisable = false
            } else {
                this.isDisable = true
            }
        },
        //重置
        onQueryClean() {
            //this.SearchuserName='';//清空搜索条件2017/10/25
            this.query = this.getSearchData()
            this.getList();
        },
        //分页选定行
        handleSizeChange: function (val) {
            this.pageSize = val;
            this.getList();
        },
        //分页监听dd页面
        handleCurrentChange: function (val) {
            this.pageIndex = val;
            //this.getList();
            this.onQueryClean(); //重置搜索条件刷新2017/10/25
        },
        handleCurrentChange2: function (val) {
            this.pageIndex = val;
            this.getList();
        },
        viewHandle(item) {
            this.view = true;
            this.TitleContent = "查看账号";
            this.GetEmployeeById(item);
        },
        editHandle(item) {
            this.edit = true;
            this.TitleContent = "修改账号";
            this.GetEmployeeById(item);
        },
        addHandle() {
            this.TitleContent = "添加账号"
            this.AddEmployeeVisible = true;
        },
        addDialogClose() {
            this.AddEmployeeVisible = false;
            this.edit = false;
            this.view = false;
            this.ActionPartment = {};
            this.ActionEmployee = {};
            this.resetEditAddForm();
            this.$refs['ruleForm'].resetFields();
            this.checkedListBtnName = [];
        },
        resetEditAddForm() {
            this.Form = this.getFormData();
            this.clearSelectArea();
        },
        selectedStaff(item) {
            this.ActionEmployee.name = item.name;
            this.ActionEmployee.ID = item.ID;
        },
        selectArea() {
            this.$refs.refSelectAreaDialog.show({
                checkedList: this.checkedProvinceList
            });
        },
        getSelectAreaCheckedNode(checkedNode) {
            this.checkedProvinceList = checkedNode;
            this.Form.ModuleRoleList[0].ListProvRole = [];
            for (var i = 0; i < checkedNode.length; i++) {
                var element = checkedNode[i];
                this.Form.ModuleRoleList[0].ListProvRole.push(element.Id);
            }
            this.setProvAreaTxt(this.checkedProvinceList);
        },
        setProvAreaTxt(plist) {
            let areaText = '';
            for (var i = 0; i < plist.length; i++) {
                areaText += plist[i].Name + "、";
            }
            this.provinceTextarea = areaText;
        },
        clearSelectArea() {
            this.checkedProvinceList = [];
            this.provinceTextarea = "";
            this.Form.ModuleRoleList[0].ListProvRole = [];
        },
        clearCheckedAreaTxtHandle() {
            this.$confirm('是否清“按区域” ?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.clearSelectArea();
            }).catch(() => {

            });
        }
    },
    computed: {
        sysSid: function () {
            return this.$store.state.sysSid;
        },
        sysSession: function () {
            return this.$store.state.sysSession;
        }
    },
    //组件初始化
    created() {
        this.getList();
        this.getEmployee();
        this.getCrmfig(14); //获取工作地列表
    }
}


// WEBPACK FOOTER //
// ./src/pages/personManage/EmployeeManage/vm.js